export type UIElement = 'scrollbar' | 'button' | 'pill' | 'notificationBubble' | 'buttonIcon' | 'paginationIndicator' | 'segmentedControl';

export enum UIElementEnum {
    SCROLLBAR = 'scrollbar',
    BUTTON = 'button',
    PILL = 'pill',
    NOTIFICATION_BUBBLE = 'notificationBubble',
    BUTTON_ICON = 'buttonIcon',
    PAGINATION_INDICATOR = 'paginationIndicator',
    SEGMENTED_CONTROL = 'segmentedControl',
}
